import { render } from "./ModalQuiz.vue?vue&type=template&id=0a5f857d&scoped=true"
import script from "./ModalQuiz.vue?vue&type=script&lang=js"
export * from "./ModalQuiz.vue?vue&type=script&lang=js"

import "./ModalQuiz.vue?vue&type=style&index=0&id=0a5f857d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a5f857d"

export default script